import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, MessageCircle, Phone } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const waHref = `https://wa.me/40734154845?text=${encodeURIComponent(`Bună ziua! Aș dori să comand produsul: ${product.name}`)}`;

  return (
    <div
      className="group flex flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-[0_8px_32px_rgba(2,132,199,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(2,132,199,0.12)]"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/produs/${product.slug}`} className="relative block overflow-hidden bg-sky-50/60 p-6">
        {product.featured && (
          <span className="absolute left-4 top-4 z-10 rounded-full bg-emerald-500 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">
            Recomandat
          </span>
        )}
        <img
          src={product.image}
          alt={product.name}
          className="mx-auto h-56 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <span className="label-caps mb-1 text-sky-600">{product.category}</span>
        <Link to={`/produs/${product.slug}`}>
          <h3 className="font-display text-base font-bold leading-snug text-slate-900 transition-colors group-hover:text-sky-700">
            {product.name}
          </h3>
        </Link>

        {/* Butoane sub titlu */}
        <div className="mt-3 flex flex-col gap-2">
          <Button
            size="sm"
            className="w-full rounded-full bg-sky-600 hover:bg-sky-500"
            onClick={() => addItem(product)}
            data-testid={`add-to-cart-${product.slug}`}
          >
            <ShoppingCart className="mr-1.5 h-4 w-4" /> Adaugă în coș
          </Button>
          <div className="grid grid-cols-2 gap-2">
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              data-testid={`whatsapp-${product.slug}`}
              className="inline-flex items-center justify-center gap-1.5 rounded-full bg-emerald-500 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-emerald-600"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            <a
              href="tel:+40734154845"
              onClick={(e) => e.stopPropagation()}
              data-testid={`call-${product.slug}`}
              className="inline-flex items-center justify-center gap-1.5 rounded-full border border-slate-200 px-3 py-2 text-xs font-semibold text-slate-700 transition-colors hover:border-sky-300 hover:text-sky-600"
            >
              <Phone className="h-4 w-4" /> Sună-ne
            </a>
          </div>
        </div>

        <p className="mt-3 line-clamp-2 text-sm text-slate-500">{product.description}</p>
        <div className="mt-auto flex items-end justify-between pt-4">
          <div className="flex flex-col">
            {product.old_price && (
              <span className="text-xs text-slate-400 line-through">{formatPrice(product.old_price)}</span>
            )}
            <span className="font-display text-xl font-extrabold text-slate-900">{formatPrice(product.price)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
